export const experienceData = [
    {
        id: 1,
        company: 'NetApp',
        jobtitle: 'Software Engineer 1',
        startYear: 'May 2024',
        endYear: 'Current'
    },
    {
        id: 2,
        company: 'Aviato Consulting',
        jobtitle: 'Backend Developer',
        startYear: 'Jun 2023',
        endYear: 'May 2024'
    },
    {
        id: 3,
        company: 'The Hustler Team',
        jobtitle: 'Web Developer Intern',
        startYear: 'Dec 2021',
        endYear: 'Feb 2022'
    }
]
